<template>
  <div>
    <Modal v-model="visible" title="请选择需要结算的数据" width="1400" :mask-closable="false" :footer-hide="true" :fullscreen="true">
      <div class="search-container">
        <div class="search-box" :class="{ close: !searchMore }">
          <div class="input-item" v-if="$units.superviseShowVal()">
            <span class="label">供应商类型</span>
            <RadioGroup v-model="formData.supplierType" @on-change="changeSupplierType">
              <Radio label="">全部</Radio>
              <Radio label="1">保司</Radio>
              <Radio label="2">通道</Radio>
            </RadioGroup>
          </div>

          <div class="input-item" v-if="formData.supplierType">
            <span class="label">供应商</span>
            <Select v-model="formData.supplierId" placeholder="请选择" filterable clearable transfer>
              <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">保险公司</span>
            <Select v-model="formData.companyCode" placeholder="请选择" filterable clearable transfer>
              <Option v-for="(bean, i) in companyList" :key="i" :value="bean.code">{{ bean.name }}</Option>
            </Select>
          </div>

          <div class="input-item select-two">
            <Select v-model="dateType" :transfer="true">
              <Option value="3">生效日期</Option>
              <Option value="1">投保日期</Option>
              <Option value="2">承保日期</Option>
              <Option value="4">退保日期</Option>
            </Select>
            <DatePicker
              type="daterange"
              split-panels
              separator="至"
              :transfer="true"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
              :value="date"
              @on-change="date = $event"
            ></DatePicker>
          </div>

          <div class="input-item">
            <span class="label">产品名称</span>
            <Select v-model="formData.productCode" clearable transfer filterable>
              <Option :value="item.productCode" v-for="(item, index) in productList" :key="index">{{ item.productCode }}/{{ item.productName }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">险种分类</span>
            <Select v-model="formData.themeIds" clearable transfer filterable multiple>
              <Option :value="item.themeId" v-for="(item, index) in productThemeList" :key="index">{{ item.title }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">业务类别</span>
            <Select
              v-model="formData.sellType"
              placeholder="请选择"
              multiple
              :disabled="formData.sellTypeStatusNull && formData.sellTypeStatusNull.length ? true : false"
            >
              <Option value="1">网销产品</Option>
              <Option value="3">经代产品</Option>
            </Select>
            <CheckboxGroup v-model="formData.sellTypeStatusNull" style="margin-left: 10px; width: 100px" @on-change="changeTimeNull($event, 'sellType')">
              <Checkbox label="1">为空</Checkbox>
            </CheckboxGroup>
          </div>

          <div class="input-item">
            <span class="label">保/批单</span>
            <Select v-model="formData.isBill" clearable transfer filterable>
              <Option value="0">保单</Option>
              <Option value="1">批单</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">保单号</span>
            <Input type="text" v-model="formData.policyNo" placeholder="请输入" />
          </div>

          <div class="input-item">
            <span class="label">批单号</span>
            <Input type="text" v-model="formData.billNo" placeholder="请输入" />
          </div>

          <div class="input-item">
            <span class="label">保单状态</span>
            <Select v-model="formData.policyStatusList" clearable transfer multiple>
              <Option value="1">已承保</Option>
              <Option value="-1">已退保</Option>
              <Option value="0">已终止</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">机构</span>
            <Select v-model="formData.orgIds" multiple clearable filterable :max-tag-count="1" @on-change="changeOrg">
              <Option v-for="(item, index) in orgList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">出单业务员</span>
            <Select placeholder="请选择" v-model="formData.salesmanId" clearable filterable>
              <Option v-for="(item, i) in userList" :key="i" :value="item.id">
                <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
                {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
              </Option>
            </Select>
          </div>

          <div class="input-item">
            <span class="label">费用归属</span>
            <Select placeholder="请选择" v-model="formData.owerId" clearable filterable>
              <Option v-for="(item, i) in userList" :key="i" :value="item.id">
                <i class="dian" :class="{ red: item.workingState == 0, orange: item.isSus == 1 }"></i>
                {{ item.staffNo ? item.staffNo + '-' + item.name : item.name }}
              </Option>
            </Select>
          </div>

          <div class="input-item">
            <span slot="label" class="label">
              是否扣款记录<span class="tip-icon">?</span>
              <div class="pop-tip">
                <span>因退保等原因已扣除费用的记录</span>
                <div class="arrow"></div>
              </div>
            </span>

            <RadioGroup v-model="formData.isDeduct" @on-change="searchAjax">
              <Radio label="">全部</Radio>
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </div>

          <div class="input-item">
            <span class="label">费用类型</span>
            <Select v-model="formData.commissionStyles" clearable transfer multiple>
              <Option value="1">基础费用</Option>
              <Option value="2">团队长基础管理费</Option>
            </Select>
          </div>
        </div>
        <div class="btn-item btn-box">
          <Button type="primary" @click="searchAjax">查询</Button>
          <Button type="primary" class="btn-reset" ghost @click="resetSearch">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore = false"
            >收起
            <Icon type="ios-arrow-up" />
          </Button>
          <Button type="primary" ghost v-else @click="searchMore = true"
            >展开
            <Icon type="ios-arrow-down" />
          </Button>
        </div>
      </div>

      <!-- 工具栏 -->
      <div class="tools-box">
        <div class="left-box">
          <Checkbox v-model="isAll" @on-change="selectAll">全部</Checkbox>
        </div>
        <div class="right-box">
          <span class="text"
            >已选择<span>{{ isAll ? total : selectArr.length }}</span
            >条，共<span>{{ total }}</span
            >条数据</span
          >
        </div>
      </div>

      <div class="tableBox">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange">
          <template slot-scope="{ row }" slot="userName_staffNo">
            <div class="name-status">
              <div class="user-box">
                <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }"></i>
                <span class="user-name">{{ row.owerStaffNo }}</span>
                <span v-if="row.owerStaffNo">/</span>
                <span class="user-name">{{ row.owerName }}</span>
              </div>
            </div>
          </template>
        </Table>
      </div>
      <Page
        :total="total"
        :current.sync="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        style="text-align: center; margin-top: 20px; margin-bottom: 50px"
      />

      <div class="footer-btn">
        <Button type="primary" @click="ok" :loading="loading">加入结算</Button>        
        <Button @click="visible = false">取消</Button>
        <Button type="warning" @click="exportTable">导出</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
import { treeFlatArr } from '@/api/filter';

export default {
  mixins: [pageTool, common],
  props: ['reportId'],
  data() {
    return {
      visible: false,
      loading: false,
      dateType: '3',
      date: [],
      formData: {
        isDeduct: '',
        supplierType: '',
        sellType: []
      },
      productList: [],
      companyList: [],
      supplierList: [],
      productThemeList: [],
      userList: [], //业务员
      total: null,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 160,
          fixed: 'left'
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180,
          render(h, params) {
            let billNo = params.row.billNo;
            return <span>{billNo ? billNo : '-'}</span>;
          },
          fixed: 'left'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '险种分类',
          align: 'center',
          key: 'themeName',
          minWidth: 120
        },
        {
          title: '保单状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.policyStatus == 1) {
              return <span>已承保</span>;
            } else if (params.row.policyStatus == 0) {
              return <span>已终止</span>;
            } else if (params.row.policyStatus == 2) {
              return <span>续保</span>;
            } else if (params.row.policyStatus == -1) {
              return <span>已退保</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用归属',
          align: 'center',
          key: 'owerName',
          minWidth: 130,
          slot: 'userName_staffNo'
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'owerType ',
          minWidth: 160,
          render(h, params) {
            const commissionType = params.row.commissionType;
            const owerType = params.row.owerType;
            if (owerType == 3 && (commissionType == 1 || commissionType == 3 || commissionType == 7 || commissionType == 9)) {
              return <span>基础费用</span>;
            }else if(owerType == 2 && (commissionType == 1 || commissionType == 3 || commissionType == 7 || commissionType == 9)){
              return <span>团队长基础管理费</span>;
            }
          },
        },
        {
          title: '费率',
          align: 'center',
          key: 'commission',
          minWidth: 120,
          render(h, params) {
            const commission = params.row.commission;
            return <span>{commission ? commission + '%' : '-'}</span>;
          }
        },
        {
          title: '费用(元)',
          align: 'center',
          key: 'commissionPrice',
          minWidth: 180,
          render(h, params) {
            const commissionPrice = params.row.commissionPrice;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            } else if (deductType == 4) {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{commissionPrice ? commissionPrice : '-'}</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Poptip>
                </div>
              );
            } else {
              return <span>{commissionPrice ? commissionPrice : '-'}</span>;
            }
          }
        },
        {
          title: '团队',
          align: 'center',
          key: 'groupName',
          minWidth: 150
        },
        {
          title: '机构',
          align: 'center',
          key: 'orgName',
          minWidth: 150
        }
      ],
      tableData: [],
      isAll: false, //全部产品
      selectArr: [], //表格选择的数据
      loading: false,
      selectOrgIds: [],
      orgList: [],
      reportName: '',
      settlementDate: ''
    };
  },
  methods: {
    async open(orgIds, reportName, settlementDate) {
      this.visible = true;
      this.isAll = false;
      this.selectArr = [];
      this.formData.orgIds = [];
      this.reportName = reportName;
      this.settlementDate = settlementDate;
      this.formData.sellType = [];
      this.date = [];
      this.dateType = '3';
      this.$set(this, 'selectOrgIds', orgIds);
      await this.getOrgList(orgIds);
      this.getSupplier();
      this.queryProduct();
      this.getBaosi();
      this.getProductTheme();
      this.getUserList(orgIds);
      this.searchAjax();
    },
    // 查询
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 重置
    resetSearch() {
      this.formData = {};
      this.formData.sellType = [];
      this.date = [];
      this.dateType = '3';
      this.formData.orgIds = this.selectOrgIds;
      this.searchAjax();
    },
    changeTimeNull(value, key) {
      this.formData[key] = '';
    },
    parameter() {
      let data = JSON.parse(JSON.stringify(this.formData));
      if (this.date && this.date[0]) {
        if (this.dateType == 1) {
          //投保日期
          data.holdTimeStart = this.date[0];
          data.holdTimeEnd = this.date[1];
        } else if (this.dateType == 2) {
          //承保日期
          data.insureTimeStart = this.date[0];
          data.insureTimeEnd = this.date[1];
        } else if (this.dateType == 3) {
          //生效日期
          data.effectTimeStart = this.date[0];
          data.effectTimeEnd = this.date[1];
        } else if (this.dateType == 4) {
          //退保日期
          data.refundTimeStart = this.date[0];
          data.refundTimeEnd = this.date[1];
        }
      }
      // 业务类别
      if (data.sellTypeStatusNull && data.sellTypeStatusNull.length) {
        data.sellTypeIsNull = '1';
        delete data.sellTypeStatusNull;
      } else if (data.sellType == '') {
        delete data.sellTypeStatusNull;
      } else {
        delete data.sellTypeStatusNull;
      }
      if (!data.orgIds.length) {
        data.orgIds = this.selectOrgIds;
      }
      return data;
    },
    // 获取列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/commissionLog/queryUserNeedSettle',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: '2',
          ...this.parameter(),
          sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : ''
        }
      })
        .then(res => {
          res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },
    ok() {
      if (!this.isAll && !this.selectArr.length) {
        this.$notice.alert('请至少选择一条数据');
        return;
      }

      let params = {};
      if (this.isAll) {
        params = {
          reportId: this.reportId,
          isAll: 1,
          commissionLogNeedSettleDTOList: this.selectArr,
          commissionLogNeedQuery: {
            ...this.parameter(),
            sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : '',
            type: '2'
          }
        };
      } else {
        params = {
          reportId: this.reportId,
          isAll: 0,
          commissionLogNeedSettleDTOList: this.selectArr
        };
      }
      this.$http({
        url: '/buz/userSettlementData/saveData',
        type: 'POST',
        data: params
      }).then(res => {
        this.visible = false;
        this.$notice.success('加入结算成功');
        this.$emit('success');
      });
    },
    // 导出
    exportTable() {
      let params = {
        type: '2',
        ...this.parameter(),
        settlementReportName: this.reportName,
        settlementDateStr: this.settlementDate,
        sellType: this.parameter().sellType.length ? this.parameter().sellType.join('|') : ''
      }
      this.$units.downloadFile('/buz/commissionLog/exportUserNeedSettlement', params, "POST");
    },
    // 获取供应商
    getSupplier() {
      this.$http({
        url: '/buz/insuranceChannel/read/list',
        type: 'POST',
        data: {}
      }).then(res => {
        this.supplierList = res.data;
      });
    },
    // 获取保司
    getBaosi() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: 'POST',
        data: {
          companyType: '1'
        }
      }).then(res => {
        //赠险公司列表初始化
        this.companyList = res.data;
      });
    },
    // 产品
    queryProduct() {
      this.$http({
        url: '/buz/productBase/read/array',
        type: 'POST',
        data: {
          productCategorys: ['1', '2']
        }
      }).then(res => {
        this.productList = res.data;
      });
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.formData.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all';
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list';
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then(res => {
          this.supplierList = res.data;
        });
      }
    },
    //险种分类
    getProductTheme() {
      let id = Object.keys(JSON.parse(localStorage.dic).GROUP_THEME_ID)[0];
      this.$http({
        url: '/buz/productThemeJoin/queryProductTheme',
        type: 'GET',
        data: {
          id
        }
      }).then(res => {
        this.productThemeList = treeFlatArr(this.dealTree1(res.data)).filter(item => item.level == 2);
      });
    },
    dealTree1(arr) {
      return arr.map(item => {
        if (item.checked) this.productForm.themeIds.push(item.themeId);
        return {
          ...item,
          value: item.themeId,
          label: item.name,
          title: item.name,
          expand: true,
          children: item.child && item.child.length > 0 ? this.dealTree1(item.child, item.name) : null
        };
      });
    },
    changeThemeIds(data) {
      // 1.当前选择的是父级，所有子集同步父级状态
      const cur = data[0]; //当前点击节点
      const ids = data[1]; //当前选中的所有id
      let isAdd = ids.includes(cur.value); //是否是新增勾选
      cur.children &&
        cur.children.forEach(item => {
          const index = ids.indexOf(item.value);
          if (isAdd && index == -1) {
            //新增未勾选的节点
            ids.push(item.value);
          } else if (!isAdd && index != -1) {
            //删除已勾选的节点
            ids.splice(index, 1);
          }
        });
      // 2.当前选择的是子级，处理父级
      if (cur.parentId != '0') {
        // 2.1 如果是新增勾选节点父级也新增勾选，父级如果已勾选不处理
        if (isAdd && !ids.includes(cur.parentId)) {
          ids.push(cur.parentId);
        }
        // 2.2 如果是取消勾选节点且所有同级都是取消状态时父级也取消
        if (!isAdd) {
          let isCancelAll = true; //是否是取消所有子集
          const parentData = this.productThemeJoinVOS.find(item => item.value == cur.parentId);
          parentData.children.forEach(item => {
            if (ids.includes(item.value)) {
              isCancelAll = false;
            }
          });
          if (isCancelAll) {
            const index = ids.indexOf(cur.parentId);
            if (index != -1) {
              ids.splice(index, 1);
            }
          }
        }
      }
      this.formData.themeIds = ids;
    },
    // 获取机构
    getOrgList(orgIds) {
      return this.$http({
        url: '/buz/organizationBase/queryList',
        type: 'POST',
        data: {
          ids: this.selectOrgIds
        }
      }).then(res => {
        this.orgList = res.data;
        this.$nextTick(() => {
          this.$set(this.formData, 'orgIds', orgIds);
        });
      });
    },
    //获取当前机构业务员
    getUserList(orgIds = this.formData.orgIds) {
      this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: {
          orgaList: orgIds
        }
      }).then(res => {
        this.userList = res.data;
      });
    },
    changeOrg(data) {
      if (!data.length) {
        this.getUserList(this.selectOrgIds);
      } else {
        this.getUserList(data);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-container {
  position: relative;
  .search-box {
    margin-top: 20px;
  }
  .btn-box {
    position: absolute;
    bottom: 13px !important;
    right: -10px;
  }
  .dian {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #35bf3f;
    border-radius: 50%;
    margin-right: 4px;
    vertical-align: top;
    transform: translateY(7px);
    &.red {
      background: #e3461f;
    }
    &.orange {
      background: #ff9900 !important;
    }
  }
}
/deep/ .ivu-icon-ios-close {
  color: #3c464f !important;
}
/deep/ .ivu-modal-body {
  padding-bottom: 30px !important;
}
.label {
  position: relative;
  .tip-icon {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .pop-tip {
    position: absolute;
    width: 190px;
    bottom: -40px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -0px;
    padding: 3px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      top: -4px;
      left: 29px;
      transform: rotateZ(135deg);
    }
  }
}
/deep/.ivu-modal-close {
  top: 0px;
  font-size: 30px;
}
/deep/.ivu-modal-header {
  height: 45px;
  padding-left: 20px;
}
/deep/.ivu-modal-header-inner {
  font-size: 16px;
}
.footer-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-btn {
    min-width: 100px;
    margin-right: 10px;
  }
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
.commission-price {
  display: flex;
  align-items: center;
  justify-content: center;
  .text-tag {
    margin-left: 5px;
    width: 34px;
    height: 20px;
    border-radius: 2px;
    font-size: 12px;
    color: #ff7f00;
    border: 1px solid #ffcf8e;
    background: #fff3e3;
  }
}
</style>
